/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { useCallback, useEffect, useRef } from "react";

// scope a timeout to the lifecycle of a component context so we dont
// get any errors about performing state updates on unmounted
// components.
export const useCleanedUpTimeout = (): ((
  callback: VoidFunction,
  ms: number
) => void) => {
  const timeout = useRef<NodeJS.Timeout | undefined>();

  // clear any timeouts on component unmount
  useEffect(() => {
    return (): void => {
      clearTimeout(timeout.current);
    };
  }, []);

  return useCallback((callback: VoidFunction, ms: number): void => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(callback, ms);
  }, []);
};
